import campania from "@/config/brands/index";

describe("index.js oferta export por default", () => {
  it("se exporta correctamente el deepmerge de las ofertas", () => {
    expect(campania).toBeDefined();
    expect(campania).not.toBeNull();
  });
});
